import React, { useContext } from "react";
import { MobergCheckbox, MobergColumn, MobergHeader, MobergInputLabel, MobergNumberInput, MobergRow, MobergText } from "../../../../Moberg";
import { ConfigureWindowModalContext } from "./ConfigureWindowModal";
import { SummaryValueConfig } from "../../../../Pages/Data/Visualize/DataReview/Types/Graph";
import { SolidColorTraceDataConfig } from "../../../../Pages/Data/Visualize/DataReview/Types/Trace";
import { getDefaultDecimals } from "../../../../Constants/LabelSettings";

// A measurement that has never had its numeric display set reads with its default decimals (a delta
// region with those of its first measurement).
const defaultDecimals = (trace: SolidColorTraceDataConfig): number => {
    const first = (trace as { first?: { rawDataKey?: string } }).first
    return getDefaultDecimals(first ? first.rawDataKey : trace.rawDataKey)
}

export const MultiGraphNumericDisplayConfiguration = () => {
    const { activeSourceTraces, activeAnalyticTraces, activeDeltaRegions, currentGraph, updateGraphProperty } = useContext(ConfigureWindowModalContext)
    const allTraceOptions: SolidColorTraceDataConfig[] = [...activeSourceTraces, ...activeAnalyticTraces, ...activeDeltaRegions].map(trace => ({ ...trace, color: (trace as SolidColorTraceDataConfig).color ?? "black" })) as SolidColorTraceDataConfig[]
    const updateConfig = (traceId: string, newConfig: SummaryValueConfig | undefined) => {
        updateGraphProperty("traces", (currentGraph?.traces ?? []).map(trace => {
            if (trace.id === traceId) {
                return { ...trace, summaryValueConfig: newConfig }
            }
            return trace
        }))
    }

    const validateDecimalPlaces = (decimalPlaces: number): string | undefined => {
        if (decimalPlaces < 0 || decimalPlaces > 4) {
            return "Enter a number between 0 and 4."
        }
        return undefined
    }

    const validateSummaryValueColumns = (numberOfColumns: number): string | undefined => {
        if (numberOfColumns < 1 || numberOfColumns > 3) {
            return "Enter a number between 1 and 3."
        }
        return undefined
    }

    return (
        <MobergColumn expand={false} gap="16px">
            <MobergHeader>Numeric display</MobergHeader>
            <MobergRow style={{ padding: "0 4px" }}>
                <MobergNumberInput
                    label={"Number of columns"}
                    value={currentGraph?.summaryValueColumns}
                    defaultValue={1}
                    validationFunction={validateSummaryValueColumns}
                    onChange={numberOfColumns => updateGraphProperty("summaryValueColumns", numberOfColumns)}
                />
            </MobergRow>
            <div style={{ display: "grid", gridTemplateColumns: "auto auto auto", columnGap: "16px", rowGap: "12px", padding: "0 4px", maxWidth: "fit-content", alignItems: "center" }}>
                <MobergInputLabel text={"Name"} />
                <MobergInputLabel text={"Decimals"} />
                <MobergInputLabel text={"Visible"} />
                {allTraceOptions.map(trace => {
                    return (<>
                        <MobergText>{trace.name}</MobergText>
                        <MobergNumberInput
                            defaultValue={defaultDecimals(trace)}
                            value={trace.summaryValueConfig?.precision ?? defaultDecimals(trace)}
                            validationFunction={validateDecimalPlaces}
                            onChange={precision => updateConfig(trace.id, trace.summaryValueConfig
                                ? { ...trace.summaryValueConfig, precision: precision ?? defaultDecimals(trace) }
                                : { color: trace.color, name: trace.name, precision: precision ?? defaultDecimals(trace), isVisible: false, units: trace.units })}
                        />
                        <MobergCheckbox
                            isChecked={trace.summaryValueConfig !== undefined && trace.summaryValueConfig.isVisible}
                            onChange={isVisible => updateConfig(trace.id, trace.summaryValueConfig
                                ? { ...trace.summaryValueConfig, isVisible }
                                : { color: trace.color, name: trace.name, precision: defaultDecimals(trace), isVisible, units: trace.units })}
                        />
                    </>)
                })}
            </div>
        </MobergColumn>
    )
}